import React, { useEffect, useState } from 'react'
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import axios from '../../utils/axiosInterceptor';
import TablaProductos from '../inventario/TablaProductos';
import { v4 as uuidv4 } from 'uuid';

import { DateTime } from 'luxon';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { Box, Divider, Typography, Grid, Button, Container, FormControl, TextField, Autocomplete,
    Paper, Dialog, TableRow, TableCell, Table, TableContainer,DialogTitle, 
    DialogContent, DialogActions, InputLabel, Select, MenuItem,
    TableHead, TableBody } from '@mui/material';

import CustomMessage from '../../utils/components/CustomMessage';
import CustomChip from '../../utils/components/CustomChip';

import { getDate, formatMoney, usuarios } from '../../utils/functions/Utils';

const EditarPedido = () => {
    let navigate = useNavigate();
    const auth = useSelector((state) => state.auth);

    const [data, setData] = useState([]);
    const [noPedido, setNoPedido] = useState(0);
    const [suppliers, setSuppliers] = useState([{}]);
    const [categories, setCategories] = useState([{}]);
    const [categoria, setCategoria] = useState('');
    const [proveedor, setProveedor] = useState('');
    const [fechaDePedido, setFechaDePedido] = useState(DateTime.now());
    const [fechaDeEntrega, setFechaDeEntrega] = useState(DateTime.now());

    const [solicitudAtendida, setSolicitudAtendida] = useState(false);

    const [entrega, setEntrega] = useState('');
    const [recibe, setRecibe] = useState('');

    const [tempProducts, setTempProducts] = useState([]);
    const [products, setProducts] = useState([]);

    const [gastos, setGastos] = useState({
        flete: 0,
        fleteMaritimo: 0,
        releaseFree: 0,
        aduanaImpuesto: 0,
        montacargas: 0,
        policia: 0,
        embalaje: 0,
        manoDeObra: 0,
        gastoDeVentas: 0,
    });

    const [tipoDeCambio, setTipoDeCambio] = useState(20);
    const [subtotalGastos, setSubtotalGastos] = useState(0);

    const [open, setOpen] = useState(false);

    const [entrada, setEntrada] = useState({
        tipoMovimiento: 'entrada', operacion: '', motivo: '', descripcion: '', recibe: '', estatus: '', observaciones: '', noOrden: '', entrega: ''});
    const [showEntrada, setShowEntrada] = useState(false);
    const [authKey, setAuthKey] = useState('');
    const [motivo, setMotivo] = useState('compra');
    const [motivos, setMotivos] = useState(['compra']);
    const [fecha, setFecha] = useState(DateTime.now());

    const [apiRes, setApiRes] = useState({ show: false, message: '', severity: '' }); // for custom alert message

    // get id from url
    let { id } = useParams()

    useEffect(() => {
        if (auth.user.rol !== "Admin") {
            navigate('/dashboard');
        }
        document.title = 'Editar Pedido';
    }, [auth])

    // for custom alert message
    const handleCloseMessage = (show) => {
        setApiRes(state => { return { ...state, show: show } })
    }

    useEffect(() => {
        getData();
    }, [])

    const getData = async () => {
        try {
            let res = await axios.get('/api/suppliers/');
            if (res.status === 200) {
                setSuppliers(res.data);
            }
            res = await axios.get(`/api/configs/company/${auth.user.company}`);
            if (res.status === 200) {
                setCategories(res.data.categorias);
            }
            res = await axios.get(`/api/batchs/${id}`);
            if (res.status === 200) {
                setData(res.data);
                setNoPedido(res.data.noPedido);
                setProveedor(res.data.proveedor);
                setCategoria(res.data.categoria);
                setFechaDePedido(DateTime.fromISO(res.data.fechaDePedido));
                setFechaDeEntrega(DateTime.fromISO(res.data.fechaDeEntrega));
                setTipoDeCambio(res.data.tipoDeCambio);
                setProducts(res.data.productos);
                setGastos(res.data.gastos);
                setSubtotalGastos(res.data.subtotalGastos);
                setEntrada(res.data.entrada ? res.data.entrada : entrada);
                setSolicitudAtendida(res.data.solicitudAtendida ? res.data.solicitudAtendida : false);
                setRecibe(res.data.entrada.recibe ? res.data.entrada.recibe : '');
                setEntrega(res.data.entrada.entrega ? res.data.entrada.entrega : '');
            }
        } catch (err) {
            console.log(err);
        }
    }

    const getUuid = () => { return uuidv4() };

    const handleAddProduct = ({product}) => {
        let x = {};
        x.id = product._id;
        x.nombre = product.nombre;
        x.clave = product.clave;
        x.cantidadComprada = 1;
        x.costoUnitarioAnteriorMxn = product.costoUnitario;
        x.precioUnitarioAnteriorMxn = product.precioUnitario;
        x.costoUnitario = 0;
        x.costoGeneral = 0;
        x.mixValue = 0;
        x.margen = 100;
        x.precioVentaUsd = Number(x.costoUnitario) * (x.margen/100);
        x.precioVentaUsdIva = x.precioVentaUsd * 1.16;
        x.precioVenta = x.precioVentaUsd * tipoDeCambio;
        x.precioVentaIva = x.precioVenta * 1.16;
        x.key = getUuid();
        x.descripcion = product.descripcion;
        x.categoria = product.categoria;
        x.imagen = product.imagen;
        setTempProducts(tempProducts => [...tempProducts, x]);
    }

    const handleOpen = () => {
        setOpen(true);
    };
    
      const handleClose = () => {
        setOpen(false);
    };

    const handleAddList = () => {
        setProducts(products => [...products, ...tempProducts]);
        setTempProducts([]);
        setOpen(false);
    }

    const renderSearchModal = () => {
        return(
            <Dialog
                fullWidth={true}
                maxWidth={'xl'}
                open={open}
                className='exo2'
                scroll='paper'
                onClose={handleClose}>
                    <DialogTitle >Agregar productos</DialogTitle>
                    <DialogContent>
                        <Grid container >
                            <Grid item xs={12} lg={9} >
                                <TablaProductos height={500} cotizacion={true} onAddProduct={handleAddProduct} />
                            </Grid>
                            <Grid item xs={12} lg={3} style={{padding: '0px 8px'}}>
                                <Divider className='my-3' textAlign="left">
                                    <CustomChip variant='outlined' estatus='AUTORIZADO' label='Productos selecionados' className='text-bold' />
                                </Divider>
                                <TableContainer>
                                    <Table>
                                        <TableHead sx={{ borderBottom: 'solid 1px black' }}>
                                            <TableRow>
                                                <TableCell size='small' align='center' sx={{ fontWeight: '700', fontSize: '14px' }}>Clave</TableCell>
                                                <TableCell size='small' align='center' sx={{ fontWeight: '700', fontSize: '14px' }}>Refacción</TableCell>
                                                <TableCell size='small' align='center' sx={{ fontWeight: '700', fontSize: '14px' }}>Precio Unitario</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                tempProducts.length > 0 ? tempProducts.map((ref, i) => (
                                                    <TableRow key={i}>
                                                        <TableCell size='small' align='center' sx={{ fontSize: '14px' }}>{ref.clave}</TableCell>
                                                        <TableCell size='small' align='center' sx={{ fontSize: '14px' }}>{ref.nombre}</TableCell>
                                                        <TableCell size='small' align='center' sx={{ fontSize: '14px' }}>$ {formatMoney(ref.precioUnitario)}</TableCell>
                                                    </TableRow>
                                                )) : <TableRow>
                                                    <TableCell size='small' align='center' colSpan={3} sx={{ fontSize: '1em' }}>No ha selecionado ninguna refacción</TableCell>
                                                </TableRow>
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </Grid>
                    </DialogContent>
                <DialogActions>
                    <Button color='success' variant='contained' onClick={() => handleAddList()}>Agregar productos &nbsp; <i className="fad fa-plus-circle"></i></Button>
                </DialogActions>
            </Dialog>
        )
    }

    const editProduct = (e, id) => {
        let x = products.find(x => x.id === id);
        x[e.target.name] = e.target.value;
        x.costoGeneral = Number(x.cantidadComprada) * Number(x.costoUnitario);
        x.costoTotal = Number(subtotalGastos) * (Number(x.mixValue)/100) + Number(x.costoGeneral);
        x.costoUnitarioTotal = Number(x.costoTotal)/Number(x.cantidadComprada);
        x.precioVentaUsd = (x.margen/100) * Number(x.costoUnitario);
        x.precioVentaUsdIva = x.precioVentaUsd * 1.16;
        x.precioVenta  = x.precioVentaUsd * tipoDeCambio;
        x.precioVentaIva = x.precioVenta * 1.16;

        let subtotal = products.reduce(function (tot, arr) {
            return tot + arr.costoGeneral;
        }, 0);

        products.forEach(x => {
            x.mixValue = (x.costoGeneral / subtotal) * 100;
        });

        setProducts(products => [...products]);
    }

    const handleDelete = (d, r) => {
        if (r < 2) {
            setProducts([]);
        } else {
            setProducts(products.filter(x => x._id !== d));
        }
    }

    const renderProducts = () => {
        if(products.length === 0) return null;
        return(
            <>
                <Divider className='my-3' textAlign="center">
                    <CustomChip variant='outlined' estatus='AUTORIZADO' label='Productos' className='text-bold' />
                </Divider>

                <TableContainer sx={{backgroundColor: 'comp.boxBg'}}>
                    <Table>
                        <TableHead>
                            <TableRow hover >
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Clave</TableCell>
                                <TableCell align='left' sx={{ fontWeight: '700', fontSize: '1em' }}>Concepto</TableCell>
                                <TableCell align='left' sx={{ fontWeight: '700', fontSize: '1em' }}>Inventario Comprado</TableCell>
                                <TableCell align='left' sx={{ fontWeight: '700', fontSize: '1em' }}>Costo Unitario USD</TableCell>
                                <TableCell align='right' sx={{ fontWeight: '700', fontSize: '1em' }}>Total USD</TableCell>
                                <TableCell align='right' sx={{ fontWeight: '700', fontSize: '1em' }}>Mix Value</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {products.map((ref, i) => (
                                <TableRow hover key={i} >
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.clave}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='left'>{ref.nombre}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>
                                        <FormControl required sx={{ m: 1, maxWidth: '90px' }} style={{ display: 'flex' }}>
                                            <TextField size='small' name='cantidadComprada' label="Inventario Comprado" variant="outlined" value={ref.cantidadComprada} onChange={(e) => editProduct(e, ref.id)}  />
                                        </FormControl>
                                    </TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='right'>
                                        <FormControl required sx={{ m:1,  maxWidth: '120px' }} style={{ display: 'flex' }}>
                                            <TextField size="small" name='costoUnitario' label="Costo Unitario USD" variant="outlined" value={ref.costoUnitario} onChange={(e) => editProduct(e, ref.id)}  />
                                        </FormControl>
                                    </TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='right'>{`$ ${formatMoney(ref.costoGeneral)}`}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='right'>{formatMoney(ref.mixValue)} %</TableCell>
                                    <TableCell size='small' align='center'>
                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                            <Button sx={{ minWidth: '50px' }} variant='contained' color='error' className='m-1' onClick={() => handleDelete(ref._id, products.length)}>&nbsp;<i className='fa fa-trash-alt'></i>&nbsp;</Button>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <br />
                {/* <div className='d-flex justify-content-end'>
                    <Button variant='contained' color='success' className='m-1' onClick={(e) => handleSubmit(e)}>Guardar &nbsp;&nbsp; <i className='fad fa-save' style={{ transform: 'scale(1.3)' }}></i></Button>
                </div> */}
            </>    
        )
    }

    useEffect(() => {
        const total = Object.values(gastos).reduce((t, n) => Number(t) + Number(n))
        setSubtotalGastos(total);
        const tmp = products.map(x => {
            const costoTotal = Number(total) * (Number(x.mixValue)/100) + Number(x.costoGeneral);
            const costoUnitarioTotal = Number(costoTotal)/Number(x.cantidadComprada);
            const costoUnitarioMxn = (Number(costoTotal)/Number(x.cantidadComprada))*(Number(tipoDeCambio));
            return {...x, costoTotal: costoTotal, costoUnitarioTotal: costoUnitarioTotal, costoUnitarioMxn: costoUnitarioMxn}
            
        })
        setProducts(tmp);
    }, [gastos])

    const renderCostos = () => {
        return(
            <>
                <Divider className='my-3' textAlign="center">
                    <CustomChip variant='outlined' estatus='DIAGNOSTICADO' label='Costos de Importación' className='text-bold' />
                </Divider>

                <Grid container spacing={3}>
                    <Grid item xs={12} md={3}>
                        <FormControl required sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                            <TextField size='small' label="Flete terrestre" variant="outlined" value={gastos.flete} onChange={(e) => setGastos({ ...gastos, flete: e.target.value})} />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                            <TextField size='small' label="Flete Maritimo" variant="outlined" value={gastos.fleteMaritimo} onChange={(e) => setGastos({ ...gastos, fleteMaritimo: e.target.value})} />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                            <TextField size='small' label="Release Fee/Limpieza" variant="outlined" value={gastos.releaseFree} onChange={(e) => setGastos({ ...gastos, releaseFree: e.target.value})} />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                            <TextField size='small' label="Aduana impuesto" variant="outlined" value={gastos.aduanaImpuesto} onChange={(e) => setGastos({ ...gastos, aduanaImpuesto: e.target.value})} />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                            <TextField size='small' label="Montacargas" variant="outlined" value={gastos.montacargas} onChange={(e) => setGastos({ ...gastos, montacargas: e.target.value})} />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                            <TextField size='small' label="Policias" variant="outlined" value={gastos.policia} onChange={(e) => setGastos({ ...gastos, policia: e.target.value})} />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                            <TextField size='small' label="Embalaje" variant="outlined" value={gastos.embalaje} onChange={(e) => setGastos({ ...gastos, embalaje: e.target.value})} />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                            <TextField size='small' label="Mano de obra" variant="outlined" value={gastos.manoDeObra} onChange={(e) => setGastos({ ...gastos, manoDeObra: e.target.value})} />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                            <TextField size='small' label="Gasto de ventas" variant="outlined" value={gastos.gastoDeVentas} onChange={(e) => setGastos({ ...gastos, gastoDeVentas: e.target.value})} />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                            <TextField size='small' label="Tipo de Cambio" variant="outlined" value={tipoDeCambio} onChange={(e) => setTipoDeCambio(e.target.value)} />
                        </FormControl>
                    </Grid>
                </Grid>
            </>
        )
    }

    const renderCostosTable = () => {
        if(products.length === 0) return null;
        return(
            <>
                <br />

                <TableContainer sx={{backgroundColor: '#C147E922'}}>
                    <Table>
                        <TableHead>
                            <TableRow hover >
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Clave</TableCell>
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Flete Terrestre</TableCell>
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Flete Maritimo</TableCell>
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Release Fee/Limpieza</TableCell>
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Aduana Impuesto</TableCell>
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Montacargas</TableCell>
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Policias</TableCell>
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Embalaje</TableCell>
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Mano de obra</TableCell>
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Gasto de ventas</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {products.map((ref, i) => (
                                <TableRow hover key={i} >
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.clave}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{calculateMixValue(gastos.flete, ref.mixValue)}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{calculateMixValue(gastos.fleteMaritimo, ref.mixValue)}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{calculateMixValue(gastos.releaseFree, ref.mixValue)}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{calculateMixValue(gastos.aduanaImpuesto, ref.mixValue)}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{calculateMixValue(gastos.montacargas, ref.mixValue)}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{calculateMixValue(gastos.policia, ref.mixValue)}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{calculateMixValue(gastos.embalaje, ref.mixValue)}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{calculateMixValue(gastos.manoDeObra, ref.mixValue)}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{calculateMixValue(gastos.gastoDeVentas, ref.mixValue)}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <br />
                <TableContainer sx={{backgroundColor: '#C147E911'}}>
                    <Table>
                        <TableHead>
                            <TableRow hover >
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Subtotal</TableCell>
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Tipo de Cambio</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow hover >
                                <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>$ {formatMoney(subtotalGastos)}</TableCell>
                                <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>$ {formatMoney(tipoDeCambio)}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </>                
        )
    }

    const calculateMixValue = (value, mixValue) => {
        return formatMoney(value * mixValue / 100);
    }

    const editMargen = (e, id) => {
        let x = products.find(x => x.id === id);
        x[e.target.name] = Number(e.target.value);
        x.precioVentaUsd = (Number(x.margen)/100) * Number(x.costoUnitarioTotal);
        x.precioVentaUsdIva = x.precioVentaUsd * 1.16;
        x.precioVenta  = x.precioVentaUsd * tipoDeCambio;
        x.precioVentaIva = x.precioVenta * 1.16;
        setProducts(products => [...products]);
    }

    const renderCostoTotal = () => {
        if(products.length === 0) return null;
        return(
            <>
                <Divider className='my-3' textAlign="center">
                    <CustomChip variant='outlined' estatus='DIAGNOSTICADO' label='Costo Total (USD)' className='text-bold' />
                </Divider>

                <TableContainer sx={{backgroundColor: '#ABC27033'}}>
                    <Table>
                        <TableHead>
                            <TableRow hover >
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Clave</TableCell>
                                <TableCell align='left' sx={{ fontWeight: '700', fontSize: '1em' }}>Concepto</TableCell>
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Mix Value</TableCell>
                                <TableCell align='right' sx={{ fontWeight: '700', fontSize: '1em' }}>Costo Total</TableCell>
                                <TableCell align='right' sx={{ fontWeight: '700', fontSize: '1em' }}>Costo Unitario</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {products.map((ref, i) => (
                                <TableRow hover key={i} >
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.clave}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='left'>{ref.nombre}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{formatMoney(ref.mixValue)} %</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='right'>{`$ ${formatMoney(ref.costoTotal)}`}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='right'>{`$ ${formatMoney(ref.costoUnitarioTotal)}`}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                <Divider className='my-3' textAlign="center">
                    <CustomChip variant='outlined' estatus='DIAGNOSTICADO' label='Perecio de Venta' className='text-bold' />
                </Divider>

                <TableContainer sx={{backgroundColor: '#47A99233'}}>
                    <Table>
                        <TableHead>
                            <TableRow hover >
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Clave</TableCell>
                                <TableCell align='left' sx={{ fontWeight: '700', fontSize: '1em' }}>Concepto</TableCell>
                                <TableCell align='right' sx={{ fontWeight: '700', fontSize: '1em' }}>Costo Unitario (USD)</TableCell>
                                <TableCell align='right' sx={{ fontWeight: '700', fontSize: '1em' }}>Costo Unitario (MXN)</TableCell>
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Margen %</TableCell>
                                <TableCell align='right' sx={{ fontWeight: '700', fontSize: '1em' }}>Precio Salida s/IVA (USD)</TableCell>
                                <TableCell align='right' sx={{ fontWeight: '700', fontSize: '1em' }}>Precio Salida c/IVA (USD)</TableCell>
                                <TableCell align='right' sx={{ fontWeight: '700', fontSize: '1em' }}>Precio Salida s/IVA (MXN)</TableCell>
                                <TableCell align='right' sx={{ fontWeight: '700', fontSize: '1em' }}>Precio Salida c/IVA (MXN)</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {products.map((ref, i) => (
                                <TableRow hover key={i} >
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.clave}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='left'>{ref.nombre}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='right'>{`$ ${formatMoney(ref.costoUnitarioTotal)}`}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='right'>{`$ ${formatMoney(ref.costoUnitarioMxn)}`}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>
                                        <FormControl required sx={{ m: 1, maxWidth: '90px' }} style={{ display: 'flex' }}>
                                            <TextField size='small' name='margen' label="Margen %" variant="outlined" value={ref.margen} onChange={(e) => editMargen(e, ref.id)}  />
                                        </FormControl>
                                    </TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='right'>{`$ ${formatMoney(ref.precioVentaUsd)}`}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='right'>{`$ ${formatMoney(ref.precioVentaUsdIva)}`}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='right'>{`$ ${formatMoney(ref.precioVenta)}`}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='right'>{`$ ${formatMoney(ref.precioVentaIva)}`}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <br />
                {/* <div className='d-flex justify-content-end'>
                    <Button variant='contained' color='success' className='m-1' onClick={(e) => handleSubmit(e)}>Guardar &nbsp;&nbsp; <i className='fad fa-save' style={{ transform: 'scale(1.3)' }}></i></Button>
                </div> */}
            </>    
        )
    }

    const handleSave = async (e) => {
        e.preventDefault();
        const batch = {
            noPedido: noPedido,
            proveedor: proveedor,
            categoria: categoria,
            fechaDePedido: fechaDePedido,
            fechaDeEntrega: fechaDeEntrega,
            tipoDeCambio: Number(tipoDeCambio),
            productos: products,
            gastos: gastos,
            subtotalGastos: subtotalGastos,
            entrada: {...entrada, recibe: recibe, entrega: entrega, fecha: fecha},
            descripcion: entrada.descripcion
        }

        try {
            const res = await axios.post(`/api/batchs/${data._id}`, { batch: batch});
            if (res.status === 200) {
                setApiRes({ show: true, message: 'Pedido guardado correctamente.', severity: 'success' });
                // window.location.reload();
                // setTimeout(() => {
                //     navigate('/pedidos');
                // }, 2000);
            }
        } catch (err) {
            setApiRes({ show: true, message: 'Error al guardar el pedido.', severity: 'error' });
            console.log(err);
        }
    }

    const handleShowEntrada = () => {
        setEntrada({ ...entrada, descripcion: `Entrada de productos provenientes del pedido #${noPedido} de ${categoria} - ${proveedor}` })
        setShowEntrada(true);
    }

    const handleCloseEntrada = () => {
        setShowEntrada(false);
    }

    const modalEntrada = () => {
        return(
            <Dialog
                fullWidth={true}
                maxWidth={'xl'}
                open={showEntrada}
                className='exo2'
                scroll='paper'
                onClose={handleCloseEntrada}>
                    <DialogTitle>Validar entrada de productos al almacén</DialogTitle>
                    <DialogContent>
                        <div>
                            <Grid container spacing={1}>
                                <Grid item sm={12}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField disabled label="Recibe" variant="outlined" value={entrada.recibe} />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField disabled label="Fecha de entrada" variant="outlined" value={getDate(fecha)}  />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12}>
                                    <FormControl sx={{ m: 1 }} style={{ display: 'flex' }}>
                                        <TextField label="Descripción" variant="outlined" value={entrada.descripcion} onChange={(e) => setEntrada({ ...entrada, descripcion: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12}>
                                    <TableContainer>
                                        <Table>
                                            <TableHead>
                                                <TableRow hover >
                                                    <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em', backgroundColor: '#47A99222' }} colSpan={3}>Resumen</TableCell>
                                                    <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em', backgroundColor: '#C147E922' }}colSpan={2} >Costo Unitario (MXN)</TableCell>
                                                    <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em', backgroundColor: '#C147E922' }}colSpan={2} >Precio de Venta (MXN)</TableCell>
                                                </TableRow>
                                                <TableRow hover >
                                                    <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Clave</TableCell>
                                                    <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Concepto</TableCell>
                                                    <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Cant.</TableCell>
                                                    <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Antes</TableCell>
                                                    <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Después</TableCell>
                                                    <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Antes</TableCell>
                                                    <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Después</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {products.map((ref, i) => (
                                                    <TableRow hover key={i}>
                                                        <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.clave}</TableCell>
                                                        <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.nombre}</TableCell>
                                                        <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.cantidadComprada}</TableCell>
                                                        <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>$ {formatMoney(ref.costoUnitarioAnteriorMxn)}</TableCell>
                                                        <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>$ {formatMoney(ref.costoUnitarioMxn)}</TableCell>
                                                        <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>$ {formatMoney(ref.precioUnitarioAnteriorMxn)}</TableCell>
                                                        <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>$ {formatMoney(ref.precioVenta)}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid>
                            <hr style={{margin: '24px 0px'}} />
                            <form onSubmit={(e) => handleEntrada(e)}>
                                <Grid container spacing={1}>
                                    <Grid item sm={12} >
                                        <p></p>
                                        <FormControl sx={{ m: 1, minWidth: 100, maxWidth: '500px' }} style={{ display: 'flex' }}>
                                            <TextField required type='password' label="Llave de verificación" variant="outlined" value={authKey} onChange={(e) => setAuthKey(e.target.value)} />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={12} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'start' }}>
                                        <Button variant='contained' color='primary' className='m-1 p-2' type='submit' >&nbsp;Confirmar entrada &nbsp;&nbsp;<i className='fad fa-badge-check' style={{ transform: 'scale(1.3)' }}></i>&nbsp;</Button>
                                    </Grid>
                                </Grid>
                            </form>
                        </div>
                    <br />
                    </DialogContent>
                <DialogActions>
                    <Button color='warning' variant='contained' onClick={() => handleCloseEntrada()}>Cerrar</Button>
                </DialogActions>
            </Dialog>
        )
    }

    const handleEntrada = async (e) => {
        e.preventDefault();

        const tmpProducts = products.map(x => {
            return {
                id: x.id,
                nombre: x.nombre,
                clave: x.clave,
                precioUnitario: x.precioVenta,
                costoUnitario: x.costoUnitarioMxn,
                cantidad: x.cantidadComprada,
                descripcion: x.descripcion,
                imagen: '',
                printImage: false,
                key: x.key,
            }
        })

        const tmp = {
            tipoMovimiento: 'entrada',
            motivo: motivo,
            entrada: {
                fechaDeEntrada: fecha,
                noFactura: `Pedido # ${noPedido}`,
                recibe: recibe,
                entrega: entrada.entrega,
                proveedor: proveedor,
                pedido: {
                    consecutivo: data.consecutivo,
                }
            },
            descripcion: entrada.descripcion,
            observaciones: entrada.observaciones,
            productos: tmpProducts,
            auth: auth.user.name,
            estatus: 'Consolidado',
        }

        try {
            const res = await axios.post('/api/inventories/', { inventory: tmp, authKey: authKey, user: auth.user });
            if (res.status === 200) {
                setApiRes(state => { return { ...state, show: true, message: 'Entrada de producto registrada', severity: 'success' } });
                handleSave(e).then(() =>{
                    setTimeout(() => {
                        navigate('/inventario/tablaInventario');
                    }, 2000);
                })
            }
        } catch (err) {
            setApiRes(state => { return { ...state, show: true, message: err.response.data.message, severity: 'error' } });
            console.log(err);
        }
    }

    const renderResumen = () => {
        return(
            <div>
                <Divider className='my-3' textAlign="center">
                    <CustomChip variant='outlined' estatus='AUTORIZADO' label='Resumen del pedido' className='text-bold' />
                </Divider>
                <Grid container >
                    <Grid item sm={12}>
                        <Box style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                            <Typography variant='h6'>Recibe: </Typography>
                            <Typography variant='h6' style={{margin: '0px 12px'}} color='secondary'>{recibe}</Typography>
                        </Box>
                    </Grid>
                    <Grid item sm={12}>
                        <Box style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                            <Typography variant='h6'>Fecha: </Typography>
                            <Typography variant='h6' style={{margin: '0px 12px'}} color='secondary'>{getDate(fecha)}</Typography>
                        </Box>
                    </Grid>
                    <Grid item sm={12}>
                        <Box style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                            <Typography variant='h6'>Descripción: </Typography>
                            <Typography variant='h6' style={{margin: '0px 12px'}} color='secondary'>{entrada.descripcion}</Typography>
                        </Box>
                    </Grid>
                    <Grid item sm={12}>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow hover >
                                        <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em', backgroundColor: '#47A99222' }} colSpan={3}>Resumen</TableCell>
                                        <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em', backgroundColor: '#C147E922' }}colSpan={2} >Costo Unitario (MXN)</TableCell>
                                        <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em', backgroundColor: '#C147E922' }}colSpan={2} >Precio de Venta (MXN) sin IVA</TableCell>
                                    </TableRow>
                                    <TableRow hover >
                                        <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Clave</TableCell>
                                        <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Concepto</TableCell>
                                        <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Cant.</TableCell>
                                        <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Antes</TableCell>
                                        <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Después</TableCell>
                                        <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Antes</TableCell>
                                        <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Después</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {products.map((ref, i) => (
                                        <TableRow hover key={i}>
                                            <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.clave}</TableCell>
                                            <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.nombre}</TableCell>
                                            <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.cantidadComprada}</TableCell>
                                            <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>$ {formatMoney(ref.costoUnitarioAnteriorMxn)}</TableCell>
                                            <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>$ {formatMoney(ref.costoUnitarioMxn)}</TableCell>
                                            <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>$ {formatMoney(ref.precioUnitarioAnteriorMxn)}</TableCell>
                                            <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>$ {formatMoney(ref.precioVenta)}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            </div>
        )
    }

    return (
        <>
            <Container maxWidth='xxl' style={{ marginTop: '10px' }}>
                <Paper sx={{ padding: '24px 0px' }} elevation={3}>

                    <Container maxWidth='xxl'>
                        <Box className='text-center' >
                            <Typography variant='h4' style={{ fontWeight: 700 }}>Editar pedido</Typography>
                        </Box>

                        <Button size='small' variant='outlined' onClick={() => navigate('/pedidos/verPedidos')}><i className='fad fa-arrow-left'></i> &nbsp;&nbsp;Regresar</Button>

                        <Divider variant="middle" className='my-3' />

                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <FormControl required sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <Autocomplete
                                        disablePortal
                                        freeSolo={true}
                                        onInputChange={(event, newInputValue) => setProveedor(newInputValue)}
                                        inputValue={proveedor}
                                        aria-multiline='true'
                                        options={suppliers.map((option) => option.name)}
                                        renderInput={(params) => <TextField {...params} label='Proveedor' helperText='Seleccione un proveedor de la lista.' />}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl required sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <Autocomplete
                                        disablePortal
                                        freeSolo={true}
                                        onInputChange={(event, newInputValue) => setCategoria(newInputValue)}
                                        inputValue={categoria}
                                        aria-multiline='true'
                                        options={categories.map((option) => option.nombre)}
                                        renderInput={(params) => <TextField {...params} label='Categoría' helperText='Seleccione una categoría de la lista.' />}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="# Pedido" variant="outlined" value={noPedido} onChange={(e) => setNoPedido(e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <DatePicker
                                        label="Fecha de Pedido"
                                        format="dd/MM/yyyy"
                                        value={fechaDePedido}
                                        onChange={(newValue) => setFechaDePedido(newValue)}
                                        slotProps={{ textField: { variant: 'outlined' } }}
                                    />
                                </FormControl>            
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <DatePicker
                                        label="Fecha de Entrega"
                                        format="dd/MM/yyyy"
                                        value={fechaDeEntrega}
                                        onChange={(newValue) => setFechaDeEntrega(newValue)}
                                        slotProps={{ textField: { variant: 'outlined' } }}
                                    />
                                </FormControl>            
                            </Grid>
                        </Grid>

                        <Grid container spacing={3} sx={{my: 1}}>
                            <Grid item xs={12} md={4}>
                                <Button variant="contained" color="secondary"onClick={handleOpen}>Agregar productos &nbsp; <i className="fad fa-plus-circle"></i></Button>
                            </Grid>
                        </Grid>

                        {renderProducts()}
                        {renderCostos()}
                        {renderCostosTable()}
                        {renderCostoTotal()}
                        
                        <div style={{display: 'flex', justifyContent: 'end'}}>
                            <div style={{display: 'flex', justifyContent: 'end'}}>
                                <Button variant="contained" color="success" onClick={(e) => handleSave(e)}>Guardar &nbsp; <i className="fad fa-save"></i></Button>
                            </div>
                        </div>
                        <hr></hr>

                        <Container maxWidth='xl'>
                            <Box className='text-center' >
                                <Typography variant='h5' style={{ fontWeight: 700 }}>Ingreso de productos al almacén</Typography>
                            </Box>

                            <Divider className='my-3' textAlign="left">
                                <CustomChip variant='outlined' estatus='AUTORIZADO' label='Datos de la entrada' className='text-bold' />
                            </Divider>

                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6} lg={3}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <InputLabel id="select">Recibe</InputLabel>
                                        <Select
                                            required
                                            labelId="select"
                                            value={recibe}
                                            label="Recibe"
                                            onChange={(e) => setRecibe(e.target.value)}
                                        >
                                            {usuarios.map((usuario, i) => (
                                                <MenuItem key={i} value={usuario}>{usuario}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6} lg={3}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField disabled label="Tipo de Movimiento" variant="outlined" value={entrada.tipoMovimiento} onChange={(e) => setEntrada({ ...entrada, tipoMovimiento: e.target.value})} />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6} lg={3}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <DatePicker
                                            label="Fecha de entrada"
                                            format="dd/MM/yyyy"
                                            value={fecha}
                                            onChange={(newValue) => setFecha(newValue)}
                                            slotProps={{ textField: { variant: 'outlined' } }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <InputLabel id="select">Motivo de entrada</InputLabel>
                                        <Select
                                            labelId="select"
                                            value={motivo}
                                            label="Motivo de entrada"
                                            onChange={(e) => setMotivo(e.target.value)}
                                        >
                                            {motivos.map((motivo, i) => (
                                                <MenuItem key={i} value={motivo}>{motivo}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6} lg={3}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField disabled label="No. Factura" variant="outlined" value={`Pedido # ${noPedido}`} />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6} lg={3}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <InputLabel id="select">Entrega</InputLabel>
                                        <Select
                                            required
                                            labelId="select"
                                            value={entrega}
                                            label="Entrega"
                                            onChange={(e) => setEntrega(e.target.value)}
                                        >
                                            {usuarios.map((usuario, i) => (
                                                <MenuItem key={i} value={usuario}>{usuario}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12} md={5}>
                                    <FormControl sx={{ m: 1 }} style={{ display: 'flex' }}>
                                        <TextField label="Observaciones" variant="outlined" value={entrada.observaciones} onChange={(e) => setEntrada({...entrada, observaciones: e.target.value})} />
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <br />

                            <Grid container >
                                <Grid item xs={12} sx={{display: 'flex', justifyContent: 'end'}}>
                                    <Button disabled={solicitudAtendida} variant="contained" color="secondary" onClick={handleShowEntrada}>Validar productos &nbsp; <i className="fad fa-sign-in"></i></Button>
                                </Grid>
                            </Grid>
                        </Container>

                        {renderResumen()}

                    </Container>
                </Paper>

                {renderSearchModal()}
                {modalEntrada()}

            </Container>
            <CustomMessage open={apiRes.show} message={apiRes.message} severity={apiRes.severity} handleCloseMessage={handleCloseMessage} />
        </>
    )
}

export default EditarPedido